export const PAYMENT_LOGO_SWEDEN: string =
  'https://s3.amazonaws.com/static.secretescapes.com/assets/images/payment-logos-sweden.png';
export const PAYMENT_LOGO_UK: string =
  'https://s3.amazonaws.com/static.secretescapes.com/assets/images/icons/trusted_deal.png';
